import React, { useEffect, useLayoutEffect } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SkeletonTheme } from "react-loading-skeleton";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
// css
import "react-phone-input-2/lib/style.css";
import "react-loading-skeleton/dist/skeleton.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/common.css";
import "./assets/style.css";
import "./assets/embla.css";

import runAxiosSetup from "./axios";
import MyRouts from "./routes/routes";
import useAuth from "./hooks/useAuth";
import { handleApiRequest } from "./services/handleApiRequest";
import { getCategories, getContentPages, getFaqsList } from "./redux/common/thunk";
import { manageCategories, manageContentPageList, manageFaqsList } from "./redux/common/slice";
import { getUserProfile } from "./redux/auth/thunk";
import useNotificationPermissions from "./hooks/usePermissions";
import ContextProvider from "./context/provider";
import ErrorFallback from "./fallback";

function App({ initialData = {} }) {
  useNotificationPermissions();
  const { isAuthenticated, loggedinUser } = useAuth();
  const dispatch = useDispatch();

  const handleError = (error) => {
    console.log("fallback error", error);
  };

  useLayoutEffect(() => {
    runAxiosSetup({
      authorization: loggedinUser?.token ? `Bearer ${loggedinUser?.token}` : undefined,
      userid: loggedinUser?.userId || "",
    });
  }, [loggedinUser]);

  useEffect(() => {
    if (!initialData.categories) {
      handleApiRequest(getCategories); // Get list of all categories
    } else {
      dispatch(manageCategories(initialData.categories));
    }

    if (!initialData.cmsPages) {
      handleApiRequest(getContentPages); // Get list of all content pages
    } else {
      dispatch(manageContentPageList(initialData.cmsPages));
    }

    if (!initialData.faqs) {
      handleApiRequest(getFaqsList); // Get list of all Faqs
    } else {
      dispatch(manageFaqsList(initialData.faqs));
    }

    if (process.env.REACT_APP_ENV_TYPE === "production") {
      setTimeout(() => {
        console.clear();
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      handleApiRequest(getUserProfile); // Get user profile details
    }
  }, [isAuthenticated]);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <ContextProvider>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <MyRouts initialData={initialData} />
            <Toaster position="top-right" reverseOrder={false} />
            <Tooltip id="tooltip" className="cs--react-tooltip" />
          </GoogleOAuthProvider>
        </ContextProvider>
      </SkeletonTheme>
    </ErrorBoundary>
  );
}

export default App;
